module.exports = __webpack_public_path__ + "media/icons/jpg-file-94c9267d.png";